// @ts-nocheck — W2.1 in-place migration: TS strict aplicado em waves subsequentes
import { combineUrl } from "../../utils";

import TileLayer from "ol/layer/Tile";
import CanvasLayer from "./geocloud2/layer/CanvasLayer.js";


import OSMSource from "ol/source/OSM";
import BingSource from "ol/source/BingMaps";
// ol@10.1+: Google source oficial via REST Map Tiles API (tile.googleapis.com).
// Substitui o vendor geocloud2 antigo que dependia do Maps JS SDK + scraping
// das <img> via querySelector — eliminamos CORS taint, latência de loadMap
// e o pipeline frankenstein. Map Tiles API precisa estar habilitada no
// projeto Google Cloud (378760200473).
import GoogleSource from "ol/source/Google.js";
import HereSource from "./geocloud2/source/HereSource.js";
import LRCSource from "./geocloud2/source/LrcSource.js";
import TileWMSSource from "ol/source/TileWMS";
import XYZSource from "ol/source/XYZ";


import WorldMapImagerySet from "./WorldMapImagerySet";

function generateTileLayer(mapService) {
  const imageFormat = mapService.imageFormat.toLowerCase().replace('[', '').replace(']', '');

  const tile = new TileLayer({
    visible: false,
    source: new LRCSource({
      url: combineUrl(mapService.serviceUrl, mapService.serviceName, '/L{l}/R{r}/C{c}.' + imageFormat),
      maxZoom: 22,
      attributions: mapService.copyright
    })
  });

  return tile;
}

function generateTmsTileLayer(mapService, invertedY = false) {
  const imageFormat = '.' + mapService.imageFormat.toLowerCase().replace('[', '').replace(']', '');
  const xyzPattern = invertedY ? "/{z}/{x}/{-y}" : "/{z}/{x}/{y}";

  const tile = new TileLayer({
    visible: false,
    source: new XYZSource({
      transition: 200,
      url: combineUrl(mapService.serviceUrl, mapService.serviceName, xyzPattern + imageFormat),
      attributions: mapService.copyright
    })
  });

  return tile;
}



const tileLoadFunction = (imageTile, src) => {
  imageTile.getImage().src = src + "&scrmb=" + Math.random();
};

function generateWmsTileLayer(mapService) {
  let params = { 
    "LAYERS": mapService.serviceName, 
    "TILED": true,
    "FORMAT": mapService.imageFormat === '[PNG]' ? 'image/png' : 'image/jpeg'
  };
  
  if(mapService.params) {
    try
    {
      let paramsAux = JSON.parse(mapService.params);
      params = {...paramsAux, ...params};
    }
    catch { }
  }


  return new TileLayer({
    visible: false,
    source: new TileWMSSource({
      url: mapService.serviceUrl,
      params: params,
      serverType: "geoserver",
      transition: 0.3,
      //cacheSize: 20,
      tileLoadFunction: tileLoadFunction
    }),
  });
}

function generateWorldMapLayer(mapService, config, map) {
  //Open Street Map

  if (mapService.serviceName === '[OSM]') {
    return new TileLayer({
      source: new OSMSource(),
      visible: false
    });
  }
  else if (mapService.serviceName.startsWith('[HERE_')) {
    return new TileLayer({
      visible: false,
      source: new HereSource({
        appId: config.mapHereMapsAppId,
        appCode: config.mapHereMapsAppCode,
        imagerySet: WorldMapImagerySet[mapService.serviceName]
      })
    });
  }
  else if (mapService.serviceName.startsWith('[BING_')) {
    return new TileLayer({
      visible: false,
      source: new BingSource({
        key: config.mapBingMapsKey,
        imagerySet: WorldMapImagerySet[mapService.serviceName]
      })
    });
  }
  else if (mapService.serviceName.startsWith('[GOOGLE_')) {
    // Sem mapGoogleMapsKey o createSession do Google Tiles API retorna 400 e
    // o erro fica em loop a cada re-render. Em dev o backend pode não ter a
    // chave configurada — devolve um TileLayer vazio (não-funcional) ao invés
    // de tentar e poluir o console.
    if (!config?.mapGoogleMapsKey) {
      console.warn(`[mapUtils] mapGoogleMapsKey ausente — pulando basemap ${mapService.serviceName}`);
      return new TileLayer({ visible: false });
    }
    // WorldMapImagerySet retorna roadmap|satellite|hybrid|terrain|streetviewmap.
    // ol/source/Google usa mapType ∈ {roadmap, satellite, terrain} + layerTypes
    // pra overlays. hybrid = satellite + layerRoadmap; terrain EXIGE layerRoadmap
    // (createSession retorna 400 sem ele); streetview cai pra roadmap + layerStreetview.
    const imagerySet = WorldMapImagerySet[mapService.serviceName];
    let mapType: string = imagerySet;
    let layerTypes: string[] | undefined;
    if (imagerySet === 'hybrid') {
      mapType = 'satellite';
      layerTypes = ['layerRoadmap'];
    }
    else if (imagerySet === 'terrain') {
      layerTypes = ['layerRoadmap'];
    }
    else if (imagerySet === 'streetviewmap') {
      mapType = 'roadmap';
      layerTypes = ['layerStreetview'];
    }
    return new TileLayer({
      visible: false,
      source: new GoogleSource({
        key: config.mapGoogleMapsKey,
        mapType,
        layerTypes,
        scale: 'scaleFactor2x',
        highDpi: true,
      }),
    });
  }
}


export function generateLayer(mapService, config, map) {
  let layer = null;
  if (mapService.type === '[AMAZON_S3]') {
    layer = generateTileLayer(mapService);
  }
  else if (mapService.type === '[GEOSERVER]') {
    layer = generateWmsTileLayer(mapService);
  }
  else if (mapService.type === '[TMS]') {
    layer = generateTmsTileLayer(mapService);
  }
  else if (mapService.type === '[INVERTED_Y_TMS]') {
    layer = generateTmsTileLayer(mapService, true);
  }
  else if (mapService.type === '[WORLD_MAP]') {
    layer = generateWorldMapLayer(mapService, config, map);
  }

  const dynamic = mapService.serviceName === 'smartgis:areas_observacao';

  return {
    label: mapService.name,
    serviceUrl: mapService.serviceUrl,
    serviceName: mapService.serviceName,
    value: `${mapService.id}__${mapService.serviceName}`,
    layer: layer,
    dynamic: dynamic
  };
}